
'use strict';//Indicating browser should run only in java script mode


EMRCommonSelectDiagnosisMasterList.service('CommonSelectDiagnosisMasterListService', ['$http', 'CommonService', function ($http, CommonService) {
}]);